module.exports = __webpack_public_path__ + "img/token1.e3e0dabc.png";